import { create } from "zustand"

export interface IObstructingFeatureMarkersActions {
    setOpen: (open: boolean) => void;
    toggleOpen: () => void;
}

export interface IObstructingFeatureMarkersState {
    actions: IObstructingFeatureMarkersActions;
    open: boolean;
}

const useObstructedRouteMarkersStore = create<IObstructingFeatureMarkersState>( (set) => ({
    open: true,
    actions: {
        setOpen: (open: boolean) => {
            set({open: open});
        },
        toggleOpen: () => {
            set((state) => ({open: !state.open}));
        }
    }
}));

export const useObstructingFeatureMarkersState = () => useObstructedRouteMarkersStore((state) => state.open);
export const useObstructingFeatureMarkersActions = () => useObstructedRouteMarkersStore((state) => state.actions);